module.exports = __webpack_public_path__ + "static/media/SuperShuttle_web_1.ddb38db6.jpg";